import { PlateDetailCardImage } from './PlateDetailCardImage';

export default PlateDetailCardImage;
